import { get, isResponseHeadOk } from 'lib/network/http';

function formatFileName(fileName: string, extension?: string) {
  return `${fileName
    .toLowerCase()
    .trim()
    .split(' ')
    .join('-')}${extension ? `.${extension}` : ''}`;
}

export function downloadDoc({
  fileName,
  docFile,
  docUrl,
  extension,
}: {
  fileName: string;
  docFile: Blob | undefined;
  docUrl: string | undefined;
  extension: string;
}) {
  if (window.navigator.msSaveOrOpenBlob && docFile) {
    window.navigator.msSaveOrOpenBlob(
      docFile,
      formatFileName(fileName, extension)
    );
  } else if (docUrl) {
    downloadUrl(docUrl, fileName, extension);
  }
}

function donwloadRefDoc({
  fileName,
  docFile: { current: docFile },
  docUrl: { current: docUrl },
  extension,
}: {
  fileName: string;
  docFile: React.MutableRefObject<Blob | undefined>;
  docUrl: React.MutableRefObject<string | undefined>;
  extension: string;
}) {
  downloadDoc({ fileName, docFile, docUrl, extension });
}

export async function downloadExternalUrl(
  url: string | null,
  fileName: string,
  extension: string
) {
  if (!url) return false;
  const pdfResponse = await get(
    {
      path: url,
    },
    'download-doc.tsx'
  );

  if (!isResponseHeadOk(pdfResponse)) {
    return false;
  }

  const docFile = pdfResponse && pdfResponse.blob && (await pdfResponse.blob());

  if (!docFile || !docFile.size) {
    return false;
  }

  downloadDoc({
    fileName,
    docFile,
    docUrl: URL.createObjectURL(docFile),
    extension,
  });
  return true;
}

export function downloadUrl(
  url?: string | null,
  fileName?: string,
  extension?: string
) {
  if (!url) return;
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.download = fileName ? formatFileName(fileName, extension) : '';
  document.body && document.body.appendChild(link);
  link.click();
  document.body && document.body.removeChild(link);
}

export default donwloadRefDoc;
